export default "__VITE_ASSET__B7pnC2Ju__"